<template>
    <v-dialog v-model="dialog">
        <v-row style="background: white">
            <v-col cols="2">
                <InfoSessionSideMenu v-on:cancel-dialog="cancelDialog"/>
            </v-col>
            <v-col cols="10">
                <v-data-table
                        :items="allAttendees"
                        show-select
                        :headers="headers"
                ></v-data-table>
            </v-col>
        </v-row>
    </v-dialog>
</template>

<script>
    import InfoSessionSideMenu from "./InfoSessionSideMenu";

    export default {
        name: "InfoSessionTable",
        components: {InfoSessionSideMenu},
        data: () => ({
            headers: [
                {text: 'First Name', align: 'start', value: 'firstName',},
                {text: 'Last Name', value: 'lastName'},
                {text: 'Email Address', value: 'email'},
                {text: 'Gender', value: 'gender'},
                {text: 'Phone Number', value: 'phone'},
                {text: 'Region', value: 'region'},
            ]
        }),
        mounted() {
            window.addEventListener('keydown', e => {
                if (e.key === 'Escape') {
                    this.cancelDialog()
                }
            })
        },
        methods: {
            cancelDialog() {
                let thisDialog = this.dialog
                thisDialog = false
                this.$emit('update-inner-dialog', thisDialog)
            }
        },
        props: {
            allAttendees: Array,
            dialog: Boolean,
        }
    }
</script>

<style scoped>

</style>